import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
  color: string;
  pack?: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 bg-slate-900 ${className}`} data-id="element-313">
      <div className="container mx-auto px-4" data-id="element-314">
        {title && <h2 className="font-bold text-center mb-12 text-white text-[16px] md:text-2xl" data-id="element-315">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-316">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-slate-950/70 p-6 rounded-2xl shadow-lg border border-slate-800 flex flex-col h-full" data-id="element-317">
              <div className="flex items-center gap-1 mb-4" data-id="element-318">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-slate-300 fill-slate-300" data-id="element-319" />)}
              </div>

              <p className="text-slate-300 italic mb-6 flex-grow" data-id="element-320">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-slate-800/50" data-id="element-321">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${t.color}`} data-id="element-322">
                  {t.initials}
                </div>
                <div data-id="element-323">
                  <p className="font-bold text-white text-sm" data-id="element-324">{t.name}</p>
                  <p className="text-xs text-slate-300/80" data-id="element-325">{t.location}</p>
                  {t.pack && <p className="text-xs font-medium text-slate-200 mt-0.5" data-id="element-326">
                      {t.pack}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export const initialTestimonials: Testimonial[] = [{
  initials: 'MR',
  name: 'Marcela R.',
  location: '🧑‍🏫 Docente de Aeronáutica Técnica — Buenos Aires',
  text: 'Mis alumnos por fin entienden cómo funciona la atmósfera y por qué eso cambia todo en el vuelo. Antes yo perdía horas buscando cómo explicarlo con claridad. Ahora entro con todo listo y la clase fluye sola.',
  color: 'bg-blue-600'
}, {
  initials: 'JP',
  name: 'Jorge P.',
  location: '🧑‍🏫 Profesor de Mantenimiento Aeronáutico — Córdoba',
  text: 'Nunca más llegué a una clase sin saber cómo explicar la diferencia entre una AD obligatoria y una SB recomendada. El material hace el trabajo pesado por mí.',
  color: 'bg-blue-700'
}, {
  initials: 'SL',
  name: 'Silvana L.',
  location: '🧑‍🏫 Docente de Escuela Técnica Aeronáutica — Rosario',
  text: 'Las planificaciones me ahorran horas. No improviso nunca más frente a mis alumnos.',
  color: 'bg-blue-800'
}];
export const moreTestimonials: Testimonial[] = [{
  initials: 'VT',
  name: 'Valeria T.',
  location: '🏙️ Buenos Aires',
  text: 'El tomo de aerodinámica y mecánica del vuelo le cambió la cara a mis clases. Por fin mis alumnos entienden por qué un avión entra en pérdida sin confundirse con fórmulas. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.',
  color: 'bg-blue-700',
  pack: 'MegaPack Técnico en Aeronáutica 360'
}, {
  initials: 'CR',
  name: 'Carlos R.',
  location: '🏙️ Córdoba',
  text: 'El banco de evaluaciones vale por sí solo el precio del pack. Nunca más construí un examen desde cero bajo presión. Salgo de cada bimestre con la satisfacción de tener todo resuelto.',
  color: 'bg-blue-800',
  pack: 'MegaPack + Pack Maestro Avanzado'
}, {
  initials: 'DG',
  name: 'Daniel G.',
  location: '🏙️ Mendoza',
  text: 'El bono de Proyecto Integrador y Aeronáutica del Futuro transformó al grupo más difícil que tenía. Mis alumnos conectaron todo lo del año con el mundo real de la industria. Eso no lo encontré en ningún otro material.',
  color: 'bg-blue-600',
  pack: 'MegaPack Técnico en Aeronáutica 360'
}, {
  initials: 'AM',
  name: 'Analía M.',
  location: '🏙️ Rosario',
  text: 'El tomo de planta motriz y propulsión me devolvió la seguridad en el aula. Antes perdía mucho tiempo buscando cómo explicar la diferencia entre un turbofán y un turbohélice. Ahora tengo todo organizado y mis alumnos lo entienden al primer intento.',
  color: 'bg-blue-900',
  pack: 'MegaPack Técnico en Aeronáutica 360'
}, {
  initials: 'SR',
  name: 'Sebastián R.',
  location: '🏙️ La Plata',
  text: 'El bono de mantenimiento y aeronavegabilidad fue una revelación. Mis alumnos entendieron la diferencia entre una AD y una SB en una sola clase. Eso cambió completamente el nivel de las discusiones en el aula.',
  color: 'bg-blue-700',
  pack: 'MegaPack Técnico en Aeronáutica 360'
}];